import ChatWidget from './widgets/ChatWidget';
import PipiPupuAPIClient from './PipiPupuAPIClient';
import VampiVoiceClient from './VampiVoiceClient';
import MmlApiClient from './MmlApiClient';
import ChatSocket from './ChatSocket';
import SoundManager from './SoundManager';
import { tryFetch } from './widgetLoader';
import 'animate.css/animate.min.css';
import 'allsettled-polyfill';

import './chatWidget.css';

const baseUrl = process.env.VUE_APP_PIPIPUPUBASE || `${location.protocol}//${location.host}`;
const api = new PipiPupuAPIClient(`${process.env.VUE_APP_PIPIPUPUBASE || ''}/api`);
const soundManager = new SoundManager();
const voiceApi = new VampiVoiceClient(process.env.VUE_APP_VAMPIVOICEAPIURL, process.env.VUE_APP_VAMPIVOICEAPIKEY);
const mmlApi = new MmlApiClient(process.env.VUE_APP_VAMPIMMLAPIURL, process.env.VUE_APP_VAMPIMMLAPIKEY);
const socket = new ChatSocket(`${process.env.VUE_APP_PIPIPUPUSOCKETBASE}/api/socket`);

const params = new Proxy(new URLSearchParams(window.location.search), {
	get: (searchParams, prop) => searchParams.get(prop),
});

if(!params.hash) {
	document.body.textContent = 'No hash specified';
} else {
	const hash = params.hash;

	const loadData = async () => {
		const [settings, eventTypes, giftTypes, giftThresholds, textReplacements, serviceIcons, userData] = await Promise.all([
			tryFetch(() => api.get(`widget/${encodeURIComponent(hash)}/settings/chat`), `cache-${hash}-chat-settings`),
			tryFetch(() => api.get(`widget/${encodeURIComponent(hash)}/eventTypes`), `cache-${hash}-eventTypes`),
			tryFetch(() => api.get(`widget/${encodeURIComponent(hash)}/giftTypes`), `cache-${hash}-giftTypes`, r => r?.results || []),
			tryFetch(() => api.get(`widget/${encodeURIComponent(hash)}/giftThresholds`), `cache-${hash}-giftThresholds`),
			tryFetch(() => api.get(`widget/${encodeURIComponent(hash)}/textReplacements`), `cache-${hash}-textReplacements`),
			tryFetch(() => api.get(`widget/${encodeURIComponent(hash)}/services`), `cache-${hash}-serviceIcons`),
			tryFetch(() => api.get(`widget/${encodeURIComponent(hash)}/userData`), `cache-${hash}-userData`),
		]);
		return {
			settings: settings || {},
			eventTypes: eventTypes || [],
			giftTypes: giftTypes || [],
			giftThresholds: giftThresholds || [],
			textReplacements: textReplacements || {},
			serviceIcons: serviceIcons || [],
			userData: userData || null,
		};
	}

	(async () => {
		const data = await loadData();

		const widget = new ChatWidget({
			container: document.getElementById('app'),
			soundManager,
			voiceApi,
			mmlApi,
			baseUrl,
		});

		await widget.init(data);

		async function reload() {
			const d = await loadData();
			widget.applySettings(d.settings);
			widget.applyEventTypes(d.eventTypes);
			widget.applyGiftTypes(d.giftTypes);
			widget.applyGiftThresholds(d.giftThresholds);
			widget.applyTextReplacements(d.textReplacements);
			widget.applyServiceIcons(d.serviceIcons);
			if(d.userData) widget.applyUserData(d.userData);
		}

		socket.subscribe(hash, {
			reconnect: reload,
			widgetSettingsChange: msg => {
				if(msg.widgetType !== 'chat') return;
				widget.applySettings(msg.settings);
			},
			widgetSettingsFieldChange: data => {
				if(data.widgetType !== 'chat') return;
				widget.applySettings({ ...widget.settings, [data.field]: data.value });
			},
			refresh: msg => { if(msg.widget === 'chat') location.reload(); },
			chat: data => widget._onChat(data),
			userTextReplacementsChange: data => widget.applyTextReplacements(data),
			userEventTypeChange: data => widget.applyEventType(data.eventType, data.data),
			userGiftTypeChange:  data => widget.applyGiftType(data.serviceId, data.giftType, data.data),
			userGiftThresholdsChange: async () => {
				const d = await tryFetch(
					() => api.get(`widget/${encodeURIComponent(hash)}/giftThresholds`),
					`cache-${hash}-giftThresholds`
				);
				if(d) widget.applyGiftThresholds(d);
			},
		});

		setInterval(reload, 5 * 60 * 1000);
	})().catch(err => console.error('Chat widget init error:', err));
}
